import { ViewModel,View } from "binder"
import { IStaticValueProvider } from "../IStaticValueProvider";
import  { DateEditorView } from "./dateEditor-view"

export class DateEditorViewModel extends ViewModel  implements IStaticValueProvider{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new DateEditorView();
    }
    public getTypeId(): string {
        return "VM-4252F873-F447-4F61-B621-47C17CFDEB8E"
    }

    public set value(v: moment.Moment) { this._value = v; } public get value(): moment.Moment { return this._value;} private _value: moment.Moment;

    setValue(v: string) {

    }
    getValue(): string {
        return "";
    }
    requestConfirm() {
    }

}
